import { render, staticRenderFns } from "./m-shop-form.vue?vue&type=template&id=6b854ce4&scoped=true"
import script from "./m-shop-form.vue?vue&type=script&lang=js"
export * from "./m-shop-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b854ce4",
  null
  
)

export default component.exports